import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import moment from 'moment';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import convertGroupPost from '../../helpers/convertGroupPost';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { deleteGroupPost } from 'redux/modules/groupPosts';
import { populateGroupPostComposebox } from 'redux/modules/groupPostCompose';
import { Dotdotdot, PostListItem } from 'components';
import ReactTooltip from 'react-tooltip';
import * as styles from './GroupPostItem.scss';
var GroupPostItem = (_dec = connect(function (state) {
  return {
    parsedLinks: state.groupPosts && state.groupPosts.parsedLinks ? state.groupPosts.parsedLinks : {}
  };
}, {
  deleteGroupPost: deleteGroupPost,
  populateGroupPostComposebox: populateGroupPostComposebox
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(GroupPostItem, _Component);

  var _super = _createSuper(GroupPostItem);

  function GroupPostItem() {
    var _this;

    _classCallCheck(this, GroupPostItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "handleDelete", function (postId) {
      if (window.confirm('Are you sure you want to delete this group post?')) {
        _this.props.deleteGroupPost(postId);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getIcons", function (accounts) {
      var iconClass = {
        facebookPage: 'fa-facebook-square',
        facebookProfile: 'fa-facebook-square',
        linkedInCompany: 'fa-linkedin-square',
        linkedInProfile: 'fa-linkedin-square',
        twitter: 'fa-twitter-square'
      };
      var iconColor = {
        facebookPage: '#3b5998',
        facebookProfile: '#3b5998',
        linkedInCompany: '#007bb5',
        linkedInProfile: '#007bb5',
        twitter: '#55acee'
      };
      return accounts.map(function (key, index) {
        return /*#__PURE__*/React.createElement("i", {
          className: "fa ".concat(iconClass[key], " ").concat(styles.saIcon),
          style: {
            color: iconColor[key]
          },
          key: "postingToIcon_".concat(key, "_").concat(index)
        });
      });
    });

    return _this;
  }

  _createClass(GroupPostItem, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          image = _this$props.image,
          message = _this$props.message,
          publishAt = _this$props.publishAt,
          post = _this$props.post;
      var postingTo = [];

      if (post.GroupPostOrganizations && !!post.GroupPostOrganizations.length) {
        post.GroupPostOrganizations.forEach(function (org) {
          var name = org.Organization.name;
          var accounts = [];

          if (org.GroupPostOrganizationSocialPlatforms && !!org.GroupPostOrganizationSocialPlatforms.length) {
            accounts = org.GroupPostOrganizationSocialPlatforms.map(function (platform) {
              return _.camelCase(platform.platform);
            });
            postingTo.push({
              name: name,
              accounts: accounts,
              unlinked: org.unlinked
            });
          }
        });
      }

      var isPastPost = moment(publishAt).isBefore(moment());
      var parsingLink = post.linkUrl && this.props.parsedLinks && !this.props.parsedLinks[post.id];
      var linkData = null;

      if (this.props.parsedLinks && this.props.parsedLinks[post.id]) {
        linkData = this.props.parsedLinks[post.id];
      }

      return /*#__PURE__*/React.createElement("div", {
        className: styles.postListItem
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.editBar
      }, !isPastPost && !parsingLink && /*#__PURE__*/React.createElement("i", {
        className: "".concat(styles.editBarIcon, " icon ion-edit"),
        onClick: function onClick() {
          var translatedPost = convertGroupPost(post, false, linkData);

          _this2.props.populateGroupPostComposebox(translatedPost);

          browserHistory.push('/global/group-posts/compose');
        }
      }), isPastPost && !parsingLink && /*#__PURE__*/React.createElement("i", {
        className: "".concat(styles.editBarIcon, " icon ion-android-refresh"),
        onClick: function onClick() {
          var translatedPost = convertGroupPost(post, true, linkData);

          _this2.props.populateGroupPostComposebox(translatedPost);

          browserHistory.push('/global/group-posts/compose');
        }
      }), !isPastPost && /*#__PURE__*/React.createElement("i", {
        className: "".concat(styles.editBarIcon, " icon ion-ios-trash-outline"),
        onClick: function onClick() {
          _this2.handleDelete(post.id);
        },
        style: {
          fontSize: 28
        }
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PostListItem, {
        publishAt: publishAt,
        image: parsingLink ? null : image,
        message: parsingLink ? 'Loading...' : message,
        wrapStyle: {
          display: 'flex',
          borderBottom: '1px solid #f1f1f1',
          padding: '16px 8px 12px'
        }
      }), /*#__PURE__*/React.createElement("div", {
        className: styles.postingToRow
      }, /*#__PURE__*/React.createElement("div", {
        className: styles.itemDate,
        style: {
          marginBottom: 6
        }
      }, isPastPost ? 'Posted To:' : 'Posting To:'), /*#__PURE__*/React.createElement("div", {
        className: styles.postingToWrap
      }, postingTo.map(function (org, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: styles.postingToItem,
          key: "postingToItem".concat(index),
          style: org.unlinked ? {
            cursor: 'pointer',
            opacity: '0.6'
          } : {},
          "data-tip": true,
          "data-for": org.unlinked ? 'gpostTooltip' : ''
        }, /*#__PURE__*/React.createElement("span", {
          className: styles.saText
        }, org.name), _this2.getIcons(org.accounts), /*#__PURE__*/React.createElement(ReactTooltip, {
          id: 'gpostTooltip',
          effect: "solid",
          place: "left"
        }, /*#__PURE__*/React.createElement("span", {
          style: {
            marginLeft: 2
          }
        }, "This location edited the group post.")));
      })))));
    }
  }]);

  return GroupPostItem;
}(Component)) || _class);
export { GroupPostItem as default };
GroupPostItem.defaultProps = {
  image: null,
  message: '',
  publishAt: moment(),
  postingTo: []
};